import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "8",
  height: "9",
  fill: "none",
  viewBox: "0 0 8 9"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "m5.049.501 2.959 3.916-2.959 3.916H3.674l1.375-1.815c.484-.649.88-1.166 1.188-1.54H0V3.834h6.226c-.374-.462-.77-.968-1.177-1.518L3.674.501z"
    }, null, -1)
  ])))
}
export default { render: render }